/**
 * Copyright IBM Corp. 2022, 2026
 */

import { ListItemInteractive } from './interactive'
import { ListItemTitle } from './title'
import { ListItemSeparator } from './separator'
import { ListItemCustom } from './custom'

const ListItem = {
	Interactive: ListItemInteractive,
	Title: ListItemTitle,
	Separator: ListItemSeparator,
	Custom: ListItemCustom,
}

export { ListItem }
